import React, { Component } from "react";
const moment = require("moment");

class TableEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment(new Date(this.props.date)).format("ll"),
    };
  }

  getScoreLevel() {
    return this.props.level <= 15 ? "Level " + this.props.level : "VICTORY!";
  }

  render() {
    return (
      <li className={this.props.elementClass}>
        <span className="player-name">{this.props.name}</span>
        <span className="player-score">{this.props.score}</span>
        <span
          className="input-date"
          style={{ width: "80px", "text-align": "left", margin: "auto" }}
        >
          {this.getScoreLevel()}
        </span>
        <span
          className="input-date"
          style={{ width: "100px", "text-align": "right", margin: "auto" }}
        >
          {this.state.date}
        </span>
      </li>
    );
  }
}

export default TableEntry;
